module.exports = __webpack_public_path__ + "static/img/service2.0b3a1dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/official/service2.jpg
// module id = O732
// module chunks = 0